export default __webpack_public_path__ + "static/media/27.7ad3b6d3.jpg";